import { Grid } from '@mui/material'
import { DYNAMIC_QUESTION_ELEMENT } from '../constants'
import CustomTextField from './CustomTextField'

const GroupedElements = ({ questions }) => {
  return (
    <Grid container spacing={1} justifyContent="flex-end" sx={{ width: '100%' }}>
      {questions.map((question) => {
        const Element = DYNAMIC_QUESTION_ELEMENT[question.questionType] || CustomTextField
        const {sizes, isHidden} = question

        if(isHidden){
          return null
        }
        
        return <Grid size={sizes}>
          <Element question={question} />
        </Grid>
      })}
    </Grid>
  )
}

export default GroupedElements
